import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAnnuityCalculation } from './monthly-pension-annuity-calculation';

export class MonthlyPensionJointLifeAnnuityCalculationItem
  extends MonthlyPensionAnnuityCalculation
  implements Deserializable
{
  public jointLifeAmount!: number;

  public onDeserialize(): void {
    super.onDeserialize();
  }
}
